// Decoder weight precision, typed. The values match src/lib/ogsPrecision.js, which is untyped.
// Notes: ~/comments/aos-threejs-poc/precision_OgsPrecision_typed_mirror.md

export type OgsPrecision = "fp16" | "fp32";

export const DEFAULT_OGS_PRECISION: OgsPrecision = "fp16";

/** fp16 unless the pick is fp32 — the runner still auto-downgrades when it cannot build. */
export function prefersFp16(precision: OgsPrecision): boolean {
  return precision !== "fp32";
}
